var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",on:{"click":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container",style:(`max-width:${_vm.maxWidth}px;`),on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }